import useSWR from 'swr';

export interface TokenRealTimePriceParams {
  marketKey: string; // slug
  interval: number; // 循环间隔，取点步长 - 秒
  start: number; // 时间戳 - 秒
  end: number; // // 时间戳 - 秒
  limit?: number;
  fill?: boolean;
}

export interface KlinePoint {
  close: number;
  endTime: number;
  high: number;
  interval: number;
  lastUpdate: number;
  low: number;
  open: number;
  startTime: number;
  tradeCount: number;
  volume: number;
}
export interface KlineResponse {
  count: number;
  interval: number;
  marketKey: string;
  data: KlinePoint[];
}

export function useRealTimePrice(params: TokenRealTimePriceParams) {
  const searchParams = new URLSearchParams(
    Object.entries({ ...params, fill: true })
      .filter(([, v]) => v !== undefined)
      .map(([k, v]) => [k, `${v}`]),
  );
  return useSWR<KlineResponse>(`api:/polymarket/kline?${searchParams.toString()}`, {
    refreshInterval: () => {
      if (Date.now() < params.end * 1000) {
        return params.interval * 5 * 1000;
      }
      return 0;
    },
  });
}
